import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})
export class DivisionComponent implements OnInit {
  title = 'Øv dig i at dividere';
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/division/division.component.ts